import { removeSharingLinks } from '../actions/publicActions';
import { LinkIdContainer } from 'owa-attachment-link-common';
import { logUsage } from 'owa-analytics';
import { lazyOnRemoveLink } from 'owa-recipient-permission-checker';

export function checkForRemovedLinks(
    linkIdContainer: LinkIdContainer,
    existingLinkIdMap: { [key: string]: boolean }
) {
    let removedLinks: string[] = [];

    linkIdContainer.sharingLinkIds.forEach(id => {
        if (!existingLinkIdMap[id]) {
            removedLinks = removedLinks.concat(id);
        }
    });

    if (removedLinks.length > 0) {
        removeSharingLinks(removedLinks);
        lazyOnRemoveLink.importAndExecute(linkIdContainer.composeId);
        logUsage('AttachmentComposeSPLinkRemove');
    }
}
